export default __webpack_public_path__ + "static/assigning-an-override-light-mode-f81eee0d6995b4e6ed0b826b9c926079.mp4";